// TanStack Query key factory for the community entity. Keeping the keys in
// one place lets server-state mutations elsewhere in the app invalidate
// without reaching into hook internals.

export const communityQueryKeys = {
  all: ["community"] as const,
  list: () => [...communityQueryKeys.all, "list"] as const,
  detail: (id: string) => [...communityQueryKeys.all, "detail", id] as const,
  overview: (id: string) =>
    [...communityQueryKeys.all, "overview", id] as const,
  health: (id: string) => [...communityQueryKeys.all, "health", id] as const,
} as const;
